import type {ReactElement} from 'react'
import {SwiperRef, SwiperSlide} from 'swiper/react'
import {useSwiper} from 'swiper/react'
import Image from 'next/image'
import React from 'react'
interface Props {
  image: any
  index: number
  sliderIndex: number
  setSliderIndex: any
  mainRef: any
}
export default function ProductThumbnailItem({
  image,
  index,
  sliderIndex,
  setSliderIndex,
  mainRef,
}: Props): ReactElement {
  const swiper = useSwiper()

  return (
    <>
      {mainRef.current && (
        <div
          onClick={() => {
            mainRef.current.swiper.slideTo(index)
            setSliderIndex(index)
          }}
          className="block w-full h-[80px] lg:h-[100px] relative">
          {sliderIndex !== index && (
            <div className="product-item-slider-backdrop  w-full absolute z-[5] inset-0 h-full"></div>
          )}
          <Image
            src={process.env.NEXT_PUBLIC_CDN_URL + '/' + image}
            className="w-full h-full object-cover"
            alt={'product-image'}
            width={100}
            height={100}
          />
        </div>
      )}
    </>
  )
}
